var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center h-100 d-flex justify-content-center align-items-center"},[_c('div',[_c('p',[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.messages.getLabelGettingUserInfo()))]})],2),_c('b-spinner',{staticClass:"spinner",attrs:{"label":_vm.messages.getLabelLoading()}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }